module.exports = __webpack_public_path__ + "assets/img/fc47554c00c8bd09ee2ae34f9c2376c5.svg";